export const SCLA_SALARY_RANGES = [
  'Under $25,000',
  '$25,000 to $49,999',
  '$50,000 to $74,999',
  '$75,000 to $99,999',
  '$100,000 or more',
  'Prefer not to say',
];

export const SCLA_EMPLOYMENT_STATUSES = [
  'Full-time',
  'Part-time',
  'Self-employed',
  'Not working',
  'Retired',
];

export const SCLA_CAREER_FIELDS = [
  { label: 'Software and apps', value: 'software-and-apps' },
  { label: 'Game design', value: 'game-design' },
  { label: 'Business and entrepreneurship', value: 'business-and-entrepreneurship' },
  { label: 'Engineering', value: 'engineering' },
  { label: 'Art and design', value: 'art-and-design' },
  { label: 'Health and medicine', value: 'health-and-medicine' },
  { label: 'Law', value: 'law' },
  { label: 'Not sure yet', value: 'not-sure-yet' },
  { label: 'Other', value: 'other' },
];

export const SCLA_TRANSPORTATION = [
  { label: 'Public transit', value: 'Public transit', icon: '🚌' },
  { label: 'Family drives me', value: 'Family drives me', icon: '🚗' },
  { label: 'Bike / walk', value: 'Bike / walk', icon: '🚲' },
  { label: 'I drive', value: 'I drive', icon: '🚘' },
];

export const SALARY_NOTE =
  'Only used in grouped reports for program funding. Never shared.';

export const SCLA_PARENT_EDUCATION = [
  'Some high school',
  'High school diploma or GED',
  'Some college',
  'Associate degree',
  "Bachelor's degree",
  'Graduate degree',
  'Prefer not to say',
];

const PARENT_EDUCATION_ALIASES: Record<string, string> = {
  'some high school': 'Some high school',
  'high school': 'High school diploma or GED',
  highschool: 'High school diploma or GED',
  'high school diploma': 'High school diploma or GED',
  'high school diploma or ged': 'High school diploma or GED',
  ged: 'High school diploma or GED',
  'some college': 'Some college',
  associate: 'Associate degree',
  'associate degree': 'Associate degree',
  "associate's degree": 'Associate degree',
  associates: 'Associate degree',
  bachelor: "Bachelor's degree",
  "bachelor's": "Bachelor's degree",
  "bachelor's degree": "Bachelor's degree",
  bachelors: "Bachelor's degree",
  'bachelor degree': "Bachelor's degree",
  graduate: 'Graduate degree',
  'graduate degree': 'Graduate degree',
  "master's": 'Graduate degree',
  "master's degree": 'Graduate degree',
  masters: 'Graduate degree',
  phd: 'Graduate degree',
  'prefer not to say': 'Prefer not to say',
};

export function parentEducationValue(stored: string): string {
  const key = stored.trim().toLowerCase();
  if (!key) return '';
  return PARENT_EDUCATION_ALIASES[key] || stored;
}

export function keptLegacyValue(value: string, known: string[]): string {
  if (!value) return '';
  if (known.includes(value)) return '';
  return value;
}
